import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";

import UserContext from "../../store/user-context";
import { Alert, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleFlowsWithFailedCalculationTable from "../../components/Tables/AuthModuleFlowsWithFailedCalculationTable";
import {
  createFilterReadyFlowsQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import Filters from "../../components/Header/Filters";

const AuthModuleFlowsWithFailedCalculations = (e) => {
  const [flows, setFlows] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext.selectedClientFiscalCode !== null) {
      getFlows(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getFlows = (filterCodes) => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        "StagedFlows/GetAllStagedFlowsCostNotCalculated",
        "GET",
        true,
        {
          fiscalCode: userContext.selectedClientFiscalCode,
          codes: filterCodes,
        },
        signIn,
        signOut,
        navigate,
        createFilterReadyFlowsQueryString,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFlows(response.data.stagedFlowsWithPriceNotCalculated);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  return (
    <Fragment>
      <Filters
        page="authModuleFlowsNotCalculated"
        filter={getFlows}
        setFilterCodesHandler={setFilters}
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && (
          <AuthModuleFlowsWithFailedCalculationTable
            items={flows}
            columns={[
              {
                name: "Data di predisposizione",
                type: "date",
                sortable: true,
                value: "predispositionDate",
              },
              {
                name: "Nome del flusso",
                type: "string",
                sortable: true,
                value: "name",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: false,
                value: "clientCodeName",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Stato",
                type: "string",
                sortable: false,
                value: "status",
              },
              {
                name: "Azioni",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            getFlows={getFlows}
            filters={filters}
          />
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleFlowsWithFailedCalculations;
